import { useQuery } from '@tanstack/react-query'
import $api from '../../../../API'
import type { ShadowWorkflowResponse } from '../../types'

export const useShadowWorkflowStatus = () => {
  return useQuery({
    queryKey: ['healthcheck', 'shadow-workflow'],
    queryFn: async (): Promise<ShadowWorkflowResponse> => {
      const response = await $api.get<ShadowWorkflowResponse>('/healthcheck/shadow-workflow/status')
      return response.data
    }
  })
}
